var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 42,
    viewBox: "0 0 111 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00602 18.2476H4.52151C5.63597 18.2476 6.52754 17.3618 6.52754 16.2545C6.52754 15.1473 5.63597 14.2615 4.52151 14.2615H2.00602C0.891566 14.2615 0 15.1473 0 16.2545C0 17.3618 0.891566 18.2476 2.00602 18.2476Z",
    fill: "url(#paint0_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0322266 2.42978C0.0322266 3.37886 0.700901 4.13812 1.62431 4.32793C1.62431 4.35957 1.71983 4.35957 1.87904 4.3912H6.01846C7.61054 4.3912 9.04341 5.81482 9.74393 7.27006L9.8713 7.52315C10.0942 8.06096 10.3489 8.66204 10.6355 9.32639C10.6355 9.35802 10.6673 9.35802 10.6673 9.38966C11.7181 11.8256 13.3739 12.3002 16.0167 12.3002H20.8248H26.3334L23.0219 4.80247L22.799 4.32793C22.6716 4.04321 22.5124 3.75849 22.3532 3.5054C21.7482 2.58796 20.9522 1.8287 19.9651 1.2909C19.9333 1.2909 19.9014 1.25926 19.9014 1.25926C19.8696 1.25926 19.8377 1.22762 19.8059 1.22762C19.2646 0.942901 18.7551 0.784722 18.3093 0.689815C17.6725 0.5 17.2267 0.5 17.2267 0.5H16.8128H6.27319H1.94273H1.8472C0.828268 0.563272 0.0322266 1.3858 0.0322266 2.42978Z",
    fill: "url(#paint1_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5031 37.2924C35.5349 37.2608 35.5349 37.2292 35.5667 37.1975C35.9488 36.5332 38.4643 30.5856 38.4643 30.5856C38.4643 30.5856 38.7828 29.7631 38.2733 28.9406C38.0186 28.4977 37.3817 27.9915 36.6175 28.0231H36.4902H19.2638H18.5315H17.4488H17.0986H17.0031C16.8757 28.0231 16.812 28.0548 16.7483 28.0548C15.8568 28.213 15.1562 29.0038 15.1562 29.9529C15.1562 30.9969 16.016 31.8827 17.0986 31.8827C17.1304 31.8827 17.1623 31.8827 17.1941 31.8827H18.1175C19.6141 31.8827 20.9833 33.338 21.6201 34.6983L22.9256 37.419C23.9445 39.8549 26.3645 41.5633 29.1984 41.5633C32.0642 41.5 34.4841 39.76 35.5031 37.2924Z",
    fill: "url(#paint2_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1085 2.42978C36.1085 2.71451 36.0449 2.99923 35.9175 3.22068C35.9175 3.25231 35.8857 3.28395 35.8857 3.31559C35.8857 3.34722 35.3443 4.51775 35.3443 4.54938L32.001 12.2685H46.4252C47.9218 8.85185 49.291 5.65664 50.4054 3.09414C50.9468 1.86034 49.9278 0.5 48.5905 0.5H41.84H38.1146H34.2299C35.2807 0.531636 36.1085 1.3858 36.1085 2.42978Z",
    fill: "url(#paint3_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7614 21.2531L16.6848 23.1196C16.7485 23.2462 16.8441 23.436 16.9396 23.6258C17.0351 23.8156 17.1306 24.0054 17.258 24.1636C17.3217 24.2902 17.4172 24.4167 17.4809 24.5116C18.4361 25.7454 20.1874 25.9985 21.8432 25.9985H26.5558H40.2158H40.375C41.5532 23.3411 42.8268 20.3673 44.1005 17.4568C44.3234 16.9823 44.4826 16.571 44.4826 16.223C44.4508 14.7678 43.2726 14.2616 42.5403 14.2616H42.0308H31.2365C31.1728 14.2616 31.1091 14.2933 31.0773 14.3565L29.2941 18.4375C29.2305 18.5641 29.0394 18.5641 28.9757 18.4375L28.5618 17.7099C28.4981 17.5834 28.4344 17.4885 28.3707 17.3619C27.9886 16.7292 27.511 16.1914 26.9697 15.7485C25.8871 14.8627 24.5179 14.2933 23.0532 14.23C22.9577 14.23 22.894 14.23 22.7984 14.23H17.1943H12.8002H10.5076C9.45679 14.2616 8.62891 15.1158 8.62891 16.1598C8.62891 17.1088 9.32942 17.8997 10.221 18.0579C10.2528 18.0895 10.3484 18.0895 10.5076 18.0895H12.3225C13.9146 18.0895 14.9654 19.5132 15.6659 20.9368L15.7614 21.2531Z",
    fill: "url(#paint4_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.403 18.0263L96.1299 3.97998H93.6144L101.193 20.5571L99.6961 23.7207C99.0275 25.1443 98.4225 26.0934 96.9896 26.0934C96.4483 26.0934 95.9388 25.9985 95.5567 25.8087L95.302 27.6752C95.8433 27.9283 96.6075 28.0548 97.3399 28.0548C99.8553 28.0548 100.906 26.473 101.957 24.0371L111 3.97998H108.484L102.403 18.0263Z",
    fill: "url(#paint5_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2539 7.36498C80.432 6.16282 81.8649 5.49847 83.8709 5.49847C86.9595 5.49847 88.9019 7.42825 88.9019 10.4653V11.6358C87.3098 11.2562 85.5585 11.0664 83.9983 11.0664C79.8588 11.0664 77.0886 13.1227 77.0886 16.1597C77.0886 19.1019 79.3175 21.0316 82.6609 21.0316C85.3356 21.0316 87.7237 19.6397 88.9337 17.2037L88.9974 20.7153H91.2263V10.1806C91.2263 6.25773 88.5516 3.63196 84.4122 3.63196C81.7057 3.63196 79.7315 4.45449 78.1712 5.94137L79.2539 7.36498ZM83.2977 19.3549C80.9415 19.3549 79.5086 18.0895 79.5086 16.1281C79.5086 14.1034 81.4191 12.7431 84.2848 12.7431C85.7496 12.7431 87.4053 12.9329 88.9019 13.2809C88.9337 17.1721 85.9724 19.3549 83.2977 19.3549Z",
    fill: "url(#paint6_linear_115_1058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5757 17.1404C60.722 19.5131 62.951 21.0633 66.3262 21.0633C71.0387 21.0633 74.414 17.5833 74.414 12.3002C74.414 7.1119 71.0706 3.63196 66.3262 3.63196C62.9828 3.63196 60.722 5.18211 59.5757 7.5548L59.5121 3.94832H57.2831V27.7068H59.5757V17.1404ZM65.7849 5.62501C69.5103 5.62501 72.0258 8.28242 72.0258 12.3318C72.0258 16.3812 69.5422 19.1019 65.7849 19.1019C62.0912 19.1019 59.5757 16.4128 59.5757 12.3634C59.5757 8.31406 62.0594 5.62501 65.7849 5.62501Z",
    fill: "url(#paint7_linear_115_1058)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_1058",
    x1: 1.19274e-7,
    y1: 18.2476,
    x2: 7.38833,
    y2: 14.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_1058",
    x1: 0.032227,
    y1: 12.3002,
    x2: 24.9866,
    y2: -6.07038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_1058",
    x1: 15.1563,
    y1: 41.5633,
    x2: 40.9822,
    y2: 26.8195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_1058",
    x1: 32.001,
    y1: 12.2685,
    x2: 53.3541,
    y2: 1.15042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_115_1058",
    x1: 8.62891,
    y1: 25.9985,
    x2: 34.6925,
    y2: -0.227606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_115_1058",
    x1: 93.6144,
    y1: 28.0548,
    x2: 117.68,
    y2: 22.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_115_1058",
    x1: 77.0886,
    y1: 21.0316,
    x2: 96.3823,
    y2: 15.8539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_115_1058",
    x1: 57.2831,
    y1: 27.7068,
    x2: 81.0334,
    y2: 22.1251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#E20E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 41,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87b891dce85e4c9a5dec747198792fef.svg";
export { ForwardRef as ReactComponent };